import { ProcessingOverlay } from '@components'

import { BorderRadius, Color, FormItemsGroup, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingComplianceDetails } from '../../../../hooks/missingComplianceDetails/useMissingComplianceDetails'
import { useMissingCustomerDetailsForm } from '../../contexts/missingCustomerDetailsFormContext'
import { CustomerAddressSection } from './elements/CustomerAddressSection'
import { CustomerNameSection } from './elements/CustomerNameSection'
import { CustomerTaxInfoSection } from './elements/CustomerTaxInfoSection'

export const MissingCustomerDetailsModalBody = (): ReactElement => {
  const { t } = useTranslation()
  const {
    isLoading,
    isSubmitting,
    missingCustomerDetailsForm: { Form },
  } = useMissingCustomerDetailsForm()
  const { isMissingCustomerAddress, isMissingCustomerTaxInfo } = useMissingComplianceDetails()

  const shouldShowProcessingOverlay = isLoading || isSubmitting

  return (
    <>
      {shouldShowProcessingOverlay && (
        <ProcessingOverlay borderRadius={BorderRadius.R12} color={Color.White} withAnimation />
      )}
      <Form>
        <FormItemsGroup rowSpacing={Spacing.S32}>
          <FormItemsGroup rowSpacing={Spacing.S16}>
            <Text>{t('external_invoices.missing_customer_compliance_details.modal.subtitle')}</Text>
            <CustomerNameSection />
            {isMissingCustomerTaxInfo && <CustomerTaxInfoSection />}
          </FormItemsGroup>
          {isMissingCustomerAddress && <CustomerAddressSection />}
        </FormItemsGroup>
      </Form>
    </>
  )
}
